import { UserRoles } from 'src/app/core/enums/user-roles.enum';
import { UserAdmin } from 'src/app/core/models/admin';
import { Items } from 'src/app/core/models/common/items.model';
import { Language } from 'src/app/core/models/languages.model';
import {
  ACTIONS_TEXT,
  IMAGE_SRC,
  STATUS_OPTIONS,
} from '../../shared-constants';

export enum ColumnIds {
  EMPLOYEE_ID = 'employeeId',
  USER_ID = 'loginId',
  LAST_NAME = 'familyName',
  FIRST_NAME = 'givenName',
  LOCATION = 'location',
  LOCATION_GROUP = 'locationGroup',
  USER_ROLE = 'roleName',
  EMAIL = 'email',
  LAST_LOGIN = 'lastLoggedIn',
  STATUS = 'enabled',
  ACTION = 'action',
}

export const ColumnText = {
  USER_ID: $localize`User Id`.toUpperCase(),
  EMPLOYEE_ID: $localize`Employee Id`.toUpperCase(),
  LAST_NAME: $localize`Last Name`.toUpperCase(),
  FIRST_NAME: $localize`First Name`.toUpperCase(),
  EMAIL: $localize`Email`.toUpperCase(),
  STATUS: $localize`Active`.toUpperCase(),
  LOCATION: $localize`Location`.toUpperCase(),
  LOCATION_GROUP: $localize`Location Group`.toUpperCase(),
  USER_ROLE: $localize`User Role`.toUpperCase(),
  LAST_LOGIN: $localize`Last Used`.toUpperCase(),
};

export const CONSTS = {
  WELCOME_TEXT: $localize`User Admin`,
  ACTIONS: ACTIONS_TEXT,
  REMOVE_USER_HEADER: $localize`Remove User`,
  REMOVE_USER_TEXT: $localize`Are you sure you want to remove the following user:`,
  NO: $localize`No`,
  YES: $localize`Yes`,
  ADD_USER_HEADER: $localize`Add User`,
  EDIT_USER_HEADER: $localize`Edit User`,
  VIEW_USER_HEADER: $localize`View User`,
};

export const STATUS_ICONS: Items[] = [
  { id: STATUS_OPTIONS.ACTIVE, src: IMAGE_SRC.ACTIVE, selected: true },
  { id: STATUS_OPTIONS.DEACTIVATED, src: IMAGE_SRC.CANCEL, selected: true },
];

export const MOCK_TABLE_CONSTS: UserAdmin[] = [
  {
    version: 123,
    loginId: 'abc1def',
    familyName: 'Herald',
    givenName: 'Zack',
    location: 'Boston',
    locationGroup: '653487',
    userType: 'H',
    defaultLanguage: Language.CHINESE,
    roleName: UserRoles.GROUPADMIN,
    email: 'flastName@ups.com',
    enabled: false,
  },
  {
    version: 234,
    loginId: 'abc2def',
    familyName: 'Garfield',
    givenName: 'Tom',
    location: 'Texas',
    locationGroup: 'XXXXXX',
    userType: 'H',
    defaultLanguage: Language.CHINESE,
    roleName: UserRoles.GROUPMANAGER,
    email: 'flastName@ups.com',
    enabled: false,
  },
  {
    version: 345,
    loginId: 'abc3def',
    familyName: 'Ali',
    givenName: 'Ali',
    location: 'California',
    locationGroup: '245781',
    userType: 'H',
    defaultLanguage: Language.CHINESE,
    roleName: UserRoles.USER,
    email: 'flastName@ups.com',
    enabled: true,
  },
  {
    version: 456,
    loginId: 'abc4def',
    familyName: 'Sanchez',
    givenName: 'Rick',
    location: 'Colarado',
    locationGroup: '347689',
    userType: 'H',
    defaultLanguage: Language.CHINESE,
    roleName: UserRoles.USER,
    email: 'flastName@ups.com',
    enabled: true,
  },
  {
    version: 567,
    loginId: 'abc5def',
    familyName: 'Yakov',
    givenName: 'Max',
    location: 'California',
    locationGroup: '436785',
    userType: 'H',
    defaultLanguage: Language.CHINESE,
    roleName: UserRoles.USER,
    email: 'flastName@ups.com',
    enabled: false,
  },
  {
    version: 678,
    loginId: 'abc6def',
    familyName: 'Terry',
    givenName: 'Richard',
    location: 'Arizona',
    locationGroup: '237648',
    userType: 'H',
    defaultLanguage: Language.CHINESE,
    roleName: UserRoles.USER,
    email: 'flastName@ups.com',
    enabled: false,
  },
  {
    version: 789,
    loginId: 'abc7def',
    familyName: 'Zar',
    givenName: 'Erwin',
    location: 'XXXXXXXX',
    locationGroup: '345678',
    userType: 'H',
    defaultLanguage: Language.CHINESE,
    roleName: UserRoles.GROUPADMIN,
    email: 'flastName@ups.com',
    enabled: false,
  },
  {
    version: 890,
    loginId: 'abc8def',
    familyName: 'Lee',
    givenName: 'James',
    location: 'XXXXXXXX',
    locationGroup: '467823',
    userType: 'H',
    defaultLanguage: Language.CHINESE,
    roleName: UserRoles.ADMIN,
    email: 'flastName@ups.com',
    enabled: true,
  },
  {
    version: 321,
    loginId: 'abc9def',
    familyName: 'Tong',
    givenName: 'Mike',
    location: 'XXXXXXXX',
    locationGroup: '653478',
    userType: 'H',
    defaultLanguage: Language.CHINESE,
    roleName: UserRoles.ADMIN,
    email: 'flastName@ups.com',
    enabled: true,
  },
  {
    version: 432,
    loginId: 'abc0def',
    familyName: 'Jirnov',
    givenName: 'Vlad',
    location: 'New York',
    locationGroup: '876369',
    userType: 'H',
    defaultLanguage: Language.CHINESE,
    roleName: UserRoles.USER,
    email: 'flastName@ups.com',
    enabled: true,
  },
  {
    version: 543,
    loginId: 'abc1hij',
    familyName: 'Sohay',
    givenName: 'Chris',
    location: 'Newjercy',
    locationGroup: '678299',
    userType: 'H',
    defaultLanguage: Language.CHINESE,
    roleName: UserRoles.ADMIN,
    email: 'flastName@ups.com',
    enabled: false,
  },
  {
    version: 654,
    loginId: 'abc2hij',
    familyName: 'Smith',
    givenName: 'Jack',
    location: 'XXXXXXXX',
    locationGroup: '167872',
    userType: 'H',
    defaultLanguage: Language.CHINESE,
    roleName: UserRoles.GROUP,
    email: 'flastName@ups.com',
    enabled: false,
  },
];

export const EXCEL_FILE_NAME = 'user-admin-data';
